// RR-F1 BL-1a (D-803 C4, D-828 BL-T (a)): the stand-by key, a client data file the worker imports directly. It lives in
// strategic/ (not src/data/) so the strategic core reads it inside its import boundary (boundary.test.ts); src/data/standbyConfig.ts
// re-exports it for the client. Kept out of roles.json and strategic/schemas.ts, which RR-F1 and P4a lock. Presentation only: no strategic
// column, pin or save field reads it.
import { z } from 'zod'
import standbyJson from '../data/standby.json'

export const standbyConfigSchema = z
  .object({
    comment: z.string().optional(),
    /** Stand-by ships shown per station, all roles together (0 = off: today's behaviour). */
    standbyVisiblePerStation: z.number().int().min(0).max(6),
    /** BL-1b/BL-R2: how far outside the hold orbit (R + local.json holdOrbitM; or the moor ring when larger) the stand-by point sits, metres. */
    standbyClearM: z.number().positive(),
  })
  .strict()

export type StandbyConfig = z.infer<typeof standbyConfigSchema>

/** The shipped stand-by config (validated at import). */
export const STANDBY: Readonly<StandbyConfig> = standbyConfigSchema.parse(standbyJson)
